'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = infoMessagesService;

var _tuneInRequest = require('../tuneInRequest');

var _tuneInRequest2 = _interopRequireDefault(_tuneInRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function infoMessagesService(config, apiContext) {
  var apiEndpoint = config.domains.api + '/infoMessages';

  function get(key) {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: apiEndpoint + '/' + key + '?viewmodel=false',
      noAuthHeader: true
    }, apiContext);
  }

  return {
    get: get
  };
}
//# sourceMappingURL=infoMessages.js.map